export default {
  oops: 'Ups!',
  validOrigin: 'Vælg venligst en gyldig afrejsested',
  validDestination: 'Vælg venligst en gyldig destination',
  validOutboundDate: 'Vælg venligst en gyldig afrejsedato',
  validReturnDate: 'Vælg venligst en gyldig returdato',
  validChildAges: 'Vælg alder for alle børn',
  oneChild: 'Kun 1 barn (i alderen 0-2) per voksen er tilladt',
}
